var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoursesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99998 14.6667H9.99998C13.3333 14.6667 14.6666 13.3333 14.6666 10V6.00001C14.6666 2.66668 13.3333 1.33334 9.99998 1.33334H5.99998C2.66665 1.33334 1.33331 2.66668 1.33331 6.00001V10C1.33331 13.3333 2.66665 14.6667 5.99998 14.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2534 10.18V5.05334C12.2534 4.54 11.84 4.16668 11.3334 4.20668H11.3067C10.4134 4.28001 9.06005 4.74002 8.30005 5.21335L8.22672 5.26002C8.10672 5.33335 7.90002 5.33335 7.77336 5.26002L7.66671 5.19335C6.91337 4.72002 5.56004 4.27334 4.66671 4.2C4.16004 4.16 3.7467 4.54002 3.7467 5.04668V10.18C3.7467 10.5867 4.08003 10.9733 4.48669 11.02L4.60669 11.04C5.52669 11.16 6.95339 11.6333 7.76672 12.08L7.7867 12.0867C7.90004 12.1533 8.08669 12.1533 8.19336 12.0867C9.00669 11.6333 10.44 11.1667 11.3667 11.04L11.5067 11.02C11.92 10.9733 12.2534 10.5933 12.2534 10.18Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5.39999V11.7733",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoursesIcon);
export default __webpack_public_path__ + "static/media/courses-icon.d9d9e740dae53d924391bdb3ddef3d1b.svg";
export { ForwardRef as ReactComponent };